import { ExtensionProperty, IProperty, Nullable, PropertyType } from "@gltf-transform/core3";
import { CYNCLY_MESH_METADATA } from "../constants";

interface IMeshMetadata extends IProperty {
	castShadow: boolean | null;
	visibleToCamera: boolean | null;
}

/**
 * Defines Mesh metadata attached to a {@link Mesh}. See {@link CYNCLYMeshMetadata}.
 */
export class MeshMetadata extends ExtensionProperty<IMeshMetadata> {
	public static EXTENSION_NAME = CYNCLY_MESH_METADATA;
	public extensionName = CYNCLY_MESH_METADATA;
	public propertyType = "MeshMetadata";
	public parentTypes = [PropertyType.MESH];

	protected init(): void {
		this.extensionName = CYNCLY_MESH_METADATA;
		this.propertyType = "MeshMetadata";
		this.parentTypes = [PropertyType.MESH];
	}

	protected getDefaults(): Nullable<IMeshMetadata> {
		return Object.assign(super.getDefaults() as IProperty, {
			castShadow: null,
			visibleToCamera: null,
		});
	}

	public getCastShadow(): boolean | null {
		return (this as any).get("castShadow");
	}

	public setCastShadow(castShadow: boolean | null): this {
		return (this as any).set("castShadow", castShadow);
	}

	public getVisibleToCamera(): boolean | null {
		return (this as any).get("visibleToCamera");
	}

	public setVisibleToCamera(visibleToCamera: boolean | null): this {
		return (this as any).set("visibleToCamera", visibleToCamera);
	}
}
